/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreateDatasetVersionResponse,
  GetDatasetDetailsResponse,
  GetDatasetVersionsResponse,
  UpdateActiveDatasetVersionRequest,
  UpdateActiveDatasetVersionResponse,
  UpdateDatasetRequest,
  UpdateDatasetResponse,
} from '../models/index';

export interface CreateDatasetVersionRequest {
    datasetId: string;
}

export interface GetDatasetDetailsRequest {
    datasetId: string;
}

export interface UpdateActiveDatasetVersionOperationRequest {
    datasetId: string;
    updateActiveDatasetVersionRequest: UpdateActiveDatasetVersionRequest;
}

export interface UpdateDatasetOperationRequest {
    datasetId: string;
    updateDatasetRequest: UpdateDatasetRequest;
}

/**
 * 
 */
export class DatesetControllerApi extends runtime.BaseAPI {

    /**
     */
    async createDatasetVersionRaw(requestParameters: CreateDatasetVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDatasetVersionResponse>> {
        if (requestParameters['datasetId'] == null) {
            throw new runtime.RequiredError(
                'datasetId',
                'Required parameter "datasetId" was null or undefined when calling createDatasetVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bot/dataset/{datasetId}/version`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters['datasetId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createDatasetVersion(requestParameters: CreateDatasetVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDatasetVersionResponse> {
        const response = await this.createDatasetVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDatasetDetailsRaw(requestParameters: GetDatasetDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDatasetDetailsResponse>> {
        if (requestParameters['datasetId'] == null) {
            throw new runtime.RequiredError(
                'datasetId',
                'Required parameter "datasetId" was null or undefined when calling getDatasetDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bot/dataset/{datasetId}`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters['datasetId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDatasetDetails(requestParameters: GetDatasetDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDatasetDetailsResponse> {
        const response = await this.getDatasetDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDatasetVersionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDatasetVersionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bot/dataset`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDatasetVersions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDatasetVersionsResponse> {
        const response = await this.getDatasetVersionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateActiveDatasetVersionRaw(requestParameters: UpdateActiveDatasetVersionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateActiveDatasetVersionResponse>> {
        if (requestParameters['datasetId'] == null) {
            throw new runtime.RequiredError(
                'datasetId',
                'Required parameter "datasetId" was null or undefined when calling updateActiveDatasetVersion().'
            );
        }

        if (requestParameters['updateActiveDatasetVersionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateActiveDatasetVersionRequest',
                'Required parameter "updateActiveDatasetVersionRequest" was null or undefined when calling updateActiveDatasetVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bot/dataset/{datasetId}version`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters['datasetId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateActiveDatasetVersionRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateActiveDatasetVersion(requestParameters: UpdateActiveDatasetVersionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateActiveDatasetVersionResponse> {
        const response = await this.updateActiveDatasetVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateDatasetRaw(requestParameters: UpdateDatasetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateDatasetResponse>> {
        if (requestParameters['datasetId'] == null) {
            throw new runtime.RequiredError(
                'datasetId',
                'Required parameter "datasetId" was null or undefined when calling updateDataset().'
            );
        }

        if (requestParameters['updateDatasetRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDatasetRequest',
                'Required parameter "updateDatasetRequest" was null or undefined when calling updateDataset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bot/dataset/{datasetId}`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters['datasetId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateDatasetRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateDataset(requestParameters: UpdateDatasetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateDatasetResponse> {
        const response = await this.updateDatasetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
